import { render, staticRenderFns } from "./ReleasePaymentReceipt.vue?vue&type=template&id=a96e9fd6&"
import script from "./ReleasePaymentReceipt.vue?vue&type=script&lang=js&"
export * from "./ReleasePaymentReceipt.vue?vue&type=script&lang=js&"
import style0 from "./ReleasePaymentReceipt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports